var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: _vm.grow } },
    [
      _c("w-card-title", { staticClass: "title" }, [_vm._t("title")], 2),
      _c(
        "w-card-content",
        {
          class: { className: _vm.className },
          style: { overflow: "hidden" },
          attrs: { "no-padding": "" },
        },
        [
          _c("div", { staticClass: "tinyTotal" }, [
            _vm._v(" € " + _vm._s(_vm.value) + " "),
          ]),
          _vm.diff
            ? _c(
                "div",
                { staticClass: "diff", class: _vm.diff > 0 ? "" : "open" },
                [
                  _c("w-fa", {
                    attrs: { icon: "arrow-" + (_vm.diff > 0 ? "up" : "down") },
                  }),
                  _vm._v(" " + _vm._s(_vm.diff) + " % "),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }